import React, { useState } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const Pricing = () => {
  const [activePlan, setActivePlan] = useState("Business plan");

  const pricingPlans = [
    {
      plan: "Basic plan",
      price: "99/mth",
      year: "Billed annually.",
      benefits: ["100 Call Minutes", "Basic Chat Support", "Simple Scheduling"],
    },
    {
      plan: "Business plan",
      price: "199/mth",
      year: "Billed annually.",
      benefits: [
        "500 Calls minutes",
        "Advanced Chat Support",
        "Full Scheduling System",
        "Lead Screening",
      ],
    },
    {
      plan: "Enterprise plan",
      price: "399/mth",
      year: "Billed annually.",
      benefits: [
        "Unlimited Minutes",
        "Premium Support ",
        "Custom Integration",
        "Advanced reporting and analytics",
        "Advanced custom fields",
      ],
    },
  ];

  return (
    <Container className="body-font py-5 pricing-container">
      <h1 className="text-center fs-four-title anybody-font fw-bold my-5">
        Simple, Transparent Pricing
      </h1>
      <Row className="pb-5">
        {pricingPlans.map((plan, index) => (
          <Col md={4} className="my-4" key={index}>
            <Card
              className={` text-center shadow-lg border-0 p-4 rounded-3 ${
                activePlan === plan.plan ? "bg-purple-color text-white" : ""
              }`}
              onClick={() => setActivePlan(plan.plan)}
            >
              <Card.Body className="d-flex flex-column">
                <Card.Title className="fs-six-title anybody-font fw-bold py-3">
                  ${plan.price}
                </Card.Title>
                <Card.Subtitle className="mb-2 fs-two">
                  {plan.plan}
                </Card.Subtitle>
                <Card.Text
                  className={`gray-color mb-3 ${
                    activePlan === plan.plan ? "bg-purple-color text-white" : ""
                  }`}
                >
                  {plan.year}
                </Card.Text>
                <ul className="list-unstyled text-start mt-3">
                  {plan.benefits.map((benefit, index) => (
                    <li
                      key={index}
                      className={`d-flex align-items-center mb-3 ${
                        activePlan === plan.plan ? "text-white" : "gray-color"
                      }`}
                    >
                      <img
                        src="/assets/check-icon.svg"
                        alt="Check"
                        className="me-2"
                      />
                      {benefit}
                    </li>
                  ))}
                </ul>
                <div className="mt-auto p-1 border-2">
                  <Button
                    variant="none"
                    as={Link}
                    to="/signup"
                    className={`text-center fs-one fw-bold border-0 p-2 w-100 ${
                      activePlan === plan.plan
                        ? "bg-white text-purple-color"
                        : "bg-purple-color text-white"
                    }`}
                  >
                    Get Started
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Pricing;
